import { render, staticRenderFns } from "./Plans.vue?vue&type=template&id=502f107a"
import script from "./Plans.vue?vue&type=script&lang=js"
export * from "./Plans.vue?vue&type=script&lang=js"
import style0 from "./Plans.vue?vue&type=style&index=0&id=502f107a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports